import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { insightStatusDateMap } from 'model/util/actionInsight';

const useStyles = makeStyles((theme) => ({
  card: {
    minWidth: 400,
  },
  text: {
    fontSize: theme.typography.body1.fontSize,
  },
}));

const StatusDates = ({ dates }) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader title="Status Dates" />
      <CardContent>
        <Table>
          <TableBody>
            {(dates || []).map((date) => (
              <TableRow key={date[0]}>
                <TableCell className={classes.text}>
                  {insightStatusDateMap[date[0]]}
                </TableCell>
                <TableCell className={classes.text}>{date[1]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

StatusDates.propTypes = {
  dates: PropTypes.array,
};

StatusDates.defaultProps = {
  dates: null,
};

export default StatusDates;
